/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <LayoutPrincipal>
    <ContainerWhite>
      <div class="membership-wall-container container-relative">
        
        <div v-if="mostrarLoaderProceso" class="loader-overlay-confined">
            <LoadScreen /> 
        </div>

        <div :class="{'membership-card': true, 'hidden-content': mostrarLoaderProceso}">
          <div class="icon-section">
            <i class="fa-solid fa-circle-xmark wall-icon"></i>
          </div>

          <h1 class="wall-title">¡Ups! Algo salió mal</h1>

          <p class="wall-subtitle">
            Hubo un problema al procesar tu pago. Por favor, 
            <strong>intente más tarde o comuníquese con el administrador/soporte</strong> si el problema persiste.
          </p>

          <div class="benefit-list">
            <h3>Estado de la transacción:</h3>
            <ul>
              <li><i class="fa-solid fa-circle-exclamation check-icon"></i> El cobro no fue realizado.</li>
              <li><i class="fa-solid fa-circle-exclamation check-icon"></i> Tu tarjeta no ha sido guardada.</li>
              <li><i class="fa-solid fa-circle-exclamation check-icon"></i> Código de error: ERR-PAY-001</li>
            </ul>
          </div>

          <button @click="retryPayment" class="cta-button">
            Intentar nuevamente
          </button>
          
          <p class="wall-footer">
            ¿Necesitas ayuda inmediata? Envíanos un correo a energyaniasolar@gmail.com
          </p>
        </div>
      </div>
    </ContainerWhite>
  </LayoutPrincipal>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import LayoutPrincipal from '@/layouts/layoutPrincipal.vue';
import ContainerWhite from '@/layouts/ContainerWhite.vue';
import LoadScreen from '../components/Forms/LoadScreen.vue';

const mostrarLoaderProceso = ref(true);

onMounted(() => {
    setTimeout(() => {
        mostrarLoaderProceso.value = false;
    }, 2000); 
});

const retryPayment = () => {
  mostrarLoaderProceso.value = true;
  setTimeout(() => {
      window.location.reload();
  }, 500);
};

</script>

<style scoped>
.membership-wall-container {
  --primary-color: #dc3545;
  --secondary-color: #f7f3f0;
  --text-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 76vh;
  position: relative;
}

.container-relative {
    position: relative;
}

.loader-overlay-confined {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.95); 
    z-index: 10; 
    border-radius: 15px;
}

.hidden-content {
    visibility: hidden;
    opacity: 0;
}

.membership-card {
  background: #ffffff;
  padding: 40px;
  border-radius: 15px;
  text-align: center;
  max-width: 550px;
  width: 100%;
  transition: opacity 0.3s ease;
  z-index: 5;
}

.icon-section {
  margin-bottom: 25px;
}

.wall-icon {
  font-size: 50px;
  color: var(--primary-color);
  background-color: rgba(220, 53, 69, 0.1); 
  padding: 20px;
  border-radius: 50%;
}

.wall-title {
  font-size: 30px;
  color: var(--primary-color);
  margin-bottom: 15px;
  font-weight: 700;
}

.wall-subtitle {
  font-size: 18px;
  color: var(--text-color);
  margin-bottom: 30px;
  line-height: 1.5;
  text-align: justify;
}

.benefit-list {
  text-align: left;
  margin: 30px auto;
  padding: 0 20px;
  border-left: 4px solid var(--primary-color);
}

.benefit-list h3 {
  color: var(--primary-color);
  margin-bottom: 10px;
}

.benefit-list ul {
  list-style: none;
  padding: 0;
}

.benefit-list li {
  margin-bottom: 8px;
  font-size: 16px;
  color: #555;
}

.check-icon {
  color: var(--primary-color); 
  margin-right: 8px;
}

.cta-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 15px 30px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.1s;
  width: 100%;
  margin-top: 20px;
  box-shadow: 0 4px 10px rgba(220, 53, 69, 0.4);
}

.cta-button:hover {
  background-color: #c82333; 
  transform: translateY(-2px);
}

.wall-footer {
  margin-top: 20px;
  font-size: 14px;
  color: #999;
}

@media (max-width: 600px) {
  .membership-card {
    padding: 25px 20px;
    margin: 20px;
  }

  .wall-title {
    font-size: 24px;
  }

  .wall-subtitle {
    font-size: 16px;
  }

  .cta-button {
    font-size: 18px;
  }
}
</style>